export default __webpack_public_path__ + "static/128-717a4f900bf4613986c816901716f325.jpg";